import React, { useState } from 'react'
import styled from 'styled-components'
import NumberStepper from 'components/UI/NumberStepper'
import BuySkuAmount from './BuySkuAmount'
import { COUPON_SCREEN_NAME, EVENT_ACTION, BUTTON_NAME } from 'tracking'
import { formatNumerics } from 'utils/formatUtil'
import { mobileSize } from 'theme'

const MAX_REDEEM_COUNT = 99999

const RedeemBubble = ({
  redeemCoupon,
  redeemQuota,
  userRemainQuota,
  pointsValue,
  amount,
  userPoints,
  setConfirmTooltip,
  setOpenTooltip,
  skuData,
  trackEvent,
  inDraw,
}) => {
  const { id: skuId, name: skuTitle } = skuData
  const [redeemNumber, setRedeemNumber] = useState(1)
  const confirmButtonText = amount > 0 ? '前往付款' : '確定並兌換'
  const canRedeemAmount = () => {
    const userMaxRedeemCount =
      pointsValue > 0 ? Math.floor(userPoints / pointsValue) : MAX_REDEEM_COUNT
    if (userRemainQuota) {
      return userMaxRedeemCount > userRemainQuota
        ? userRemainQuota
        : userMaxRedeemCount
    }
    return userMaxRedeemCount
  }

  const skuTrackData = {
    screen: COUPON_SCREEN_NAME.SKU,
    item_id: skuId,
    item_type: 'sku',
    item_status: 'available',
  }
  const cancelRedeem = () => {
    setOpenTooltip(false)
    const st = setTimeout(() => {
      setConfirmTooltip(false)
      clearTimeout(st)
    }, 300)
    trackEvent(EVENT_ACTION.CLICK, {
      ...skuTrackData,
      button: BUTTON_NAME.CANCEL_REDEEM,
    })
  }
  const confirmRedeem = () => {
    trackEvent(EVENT_ACTION.CLICK, {
      ...skuTrackData,
      button: BUTTON_NAME.CONFIRM_REDEEM,
    })
    redeemCoupon()
    cancelRedeem()
  }

  const totalRedeemPoints = pointsValue > 0 ? pointsValue * redeemNumber : 0
  const totalRedeemAmount = amount > 0 ? amount * redeemNumber : 0
  return (
    <>
      {inDraw && (
        <TopInfoWrapper>
          <SkuTitle>{skuTitle}</SkuTitle>
          {redeemQuota && <RedeemQuota>限兌換 {redeemQuota} 次</RedeemQuota>}
        </TopInfoWrapper>
      )}
      <RedeemBubbleWapper>
        {pointsValue > 0 && (
          <TipsText>
            你有 {formatNumerics(userPoints || 0)} 積分, 最多可兌換{' '}
            {canRedeemAmount()} 張
          </TipsText>
        )}
        <NumberWrapper>
          <RedeemNumberLable>兌換數量:</RedeemNumberLable>
          <NumberStepper
            min={1}
            max={canRedeemAmount()}
            value={redeemNumber}
            onChange={setRedeemNumber}
          />
        </NumberWrapper>
        <ButtonsWapper>
          <TotalBlock>
            <TotalLabel>合計:</TotalLabel>
            <BuySkuAmount
              pointsValue={totalRedeemPoints}
              amount={totalRedeemAmount}
            />
          </TotalBlock>
          <ButtonConfirm onClick={confirmRedeem}>
            {confirmButtonText}
          </ButtonConfirm>
        </ButtonsWapper>
      </RedeemBubbleWapper>
    </>
  )
}

const RedeemBubbleWapper = styled.div`
  padding: 16px 0;
  min-width: 300px;
  font-weight: normal;
  color: ${(p) => p.theme.color.dark100};
  @media ${mobileSize} {
    padding: 16px 12px;
  }
`
const TipsText = styled.div`
  font-size: 12px;
  text-align: right;
  padding-bottom: 8px;
`
const NumberWrapper = styled.div`
  padding: 8px;
  background-color: ${(p) => p.theme.color.blue20};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const RedeemNumberLable = styled.div`
  font-size: 16px;
`

const ButtonsWapper = styled.div`
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const TotalBlock = styled.div`
  display: flex;
  align-items: center;
`
const ButtonConfirm = styled.div`
  width: 100px;
  height: 46px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
  border: 1px solid ${(p) => p.theme.color.primary};
  color: #fff;
  background-color: ${(p) => p.theme.color.primary};
`
const TopInfoWrapper = styled.div`
  padding: 16px 12px;
  border-bottom: solid 1px ${(p) => p.theme.color.grey80};
  text-align: center;
`
const SkuTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
`
const RedeemQuota = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.color.rosiness};
  margin-top: 4px;
`
const TotalLabel = styled.span`
  padding-right: 2px;
`
export default RedeemBubble
